import { RewardType } from '@loyalty/shared-common/rewards-api-client';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { BurnRewardApiClient } from '../api/burn-reward-api-client';

type RewardDialogState =
  | { type: 'idle' }
  | { type: 'code'; code: string }
  | { type: 'campaign'; channelUuid: string; token: string }
  | { type: 'error'; error: string };

const apiClient = new BurnRewardApiClient();

export function useBurnReward(programId: string, ruleId: string, locale: string) {
  const [dialogState, setDialogState] = useState<RewardDialogState>({
    type: 'idle',
  });

  const mutation = useMutation({
    mutationFn: () => apiClient.burnReward(programId, ruleId),
    onSuccess: data => {
      const { reward } = data;

      switch (reward.type) {
        case RewardType.PROMOCODE: {
          if (!reward.promocode) {
            setDialogState({
              type: 'error',
              error: 'Failed to retrieve promo code',
            });
          } else {
            setDialogState({
              type: 'code',
              code: reward.promocode,
            });
          }
          break;
        }
        case RewardType.CAMPAIGN_ACCESS: {
          const channelInfo = reward.data?.channelInfoByLanguage?.[locale];
          const tokens = JSON.parse(reward.promocode || '{}');

          if (!channelInfo?.uniqueId || !tokens[locale]) {
            setDialogState({
              type: 'error',
              error: 'Failed to retrieve channel information',
            });
          } else {
            setDialogState({
              type: 'campaign',
              channelUuid: channelInfo.uniqueId,
              token: tokens[locale],
            });
          }
          break;
        }
        default: {
          setDialogState({
            type: 'error',
            error: 'Unknown reward type',
          });
        }
      }
    },
    onError: (error: any) => {
      setDialogState({
        type: 'error',
        error: error.message || 'Failed to purchase reward',
      });
    },
  });

  return {
    dialogState,
    burnReward: mutation.mutate,
    isLoading: mutation.isPending,
  };
}
